import type { ComponentProps } from "react";
import { LuExpand } from "react-icons/lu";

import { Button } from "@/components/ui/button";

export const EditorActionExpand = (props: ComponentProps<typeof Button>) => {
  return (
    <Button {...props}>
      <LuExpand className="text-lg" />
    </Button>
  );
};
